import classNames from 'classnames';
import moment from 'moment-timezone';
import React from 'react';
import { AlertIcon, DangerIcon, TickIcon } from '../Components/Icons';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { errorGlowBorder, green, warningGlowBorder } from '../Styles/Colours';
import styles from './DateExpiration.module.scss';

enum ProdaExpiryState {
    Active = 'active',
    Expiring = 'expiring',
    Expired = 'expired'
}

export interface DateExpirationProps {
    toDate: moment.Moment;
    fromDate: moment.Moment;
    testId: string;
}

export const DateExpiration: React.FC<DateExpirationProps> = ({ fromDate, toDate, testId }) => {
    if (!toDate.isValid() || !fromDate.isValid()) {
        return null;
    }

    fromDate.startOf('day');
    toDate.endOf('day');
    const diff = toDate.diff(fromDate, 'days');
    let expiryState = ProdaExpiryState.Active;
    if (diff <= 30 && diff > 0) {
        expiryState = ProdaExpiryState.Expiring;
    } else if (diff <= 0) {
        expiryState = ProdaExpiryState.Expired;
    }

    switch (expiryState) {
        case ProdaExpiryState.Active:
            return (
                <div className={styles.expiry} data-test-id={`dateExpiration-active-${testId}`}>
                    <div className={styles.expiryIcon}>
                        <TickIcon size='24' color={green} />
                    </div>

                    <div className={styles.expiryDetails}>
                        <span className={classNames(styles.expiryDate)}>
                            {toDate.format(ValidDateFormats.DisplaySlashSpace)}
                        </span>
                        <span className={styles.expiryIn}>
                            Expires in <span className={styles.expiryDays}>{fromDate.to(toDate, true)}</span>
                        </span>
                    </div>
                </div>
            );
        case ProdaExpiryState.Expired:
            return (
                <div className={styles.expiry} data-test-id={`dateExpiration-expired-${testId}`}>
                    <div className={styles.expiryIcon}>
                        <DangerIcon size='24' color={errorGlowBorder} />
                    </div>

                    <div className={styles.expiryDetailsExpired}>
                        <span className={styles.expiryDate}>{toDate.format(ValidDateFormats.DisplaySlashSpace)}</span>
                        <span className={styles.expiryIn}>Expired</span>
                    </div>
                </div>
            );
        case ProdaExpiryState.Expiring:
            return (
                <div className={styles.expiry} data-test-id={`dateExpiration-expiring-${testId}`}>
                    <div className={styles.expiryIcon}>
                        <AlertIcon size='24' color={warningGlowBorder} />
                    </div>

                    <div className={styles.expiryDetailsExpiring}>
                        <span className={styles.expiryDate}>{toDate.format(ValidDateFormats.DisplaySlashSpace)}</span>
                        <span className={styles.expiryIn}>
                            Expires in{' '}
                            <span className={styles.expiryDays}>
                                {diff} {diff === 1 ? 'day' : 'days'}
                            </span>
                        </span>
                    </div>
                </div>
            );
    }
};
